query GetHtmlContentForEntry($id: ID!) {
    event(changeLogId: $id) {
        payload {
            ... on Email {
                id
                # Alias because bodyHtml type for Email is !String which conflicts with type Note's bodyHtml type String
                emailBodyHtml: bodyHtml
            }
            ... on Note {
                id
                # Alias because bodyHtml type for Email is !String which conflicts with type Note's bodyHtml type String
                noteBodyHtml: bodyHtml
            }
            ... on EmailQueued {
                id
                bodyHtml
            }
            ... on EmailInteraction {
                id
                emailDelivery {
                    email {
                        id
                        bodyHtml
                    }
                }
            }
        }
    }
}
